//********* TUTORIALS *********//
import * as types from "./actionTypes";

export const toggleShowAssignQuotePopup = (showAssignQuotePopup, assignQuotePopupSaveButtons = "all") => ({
  type: types.TOGGLE_SHOW_ASSIGN_QUOTE_POPUP,
  payload: {showAssignQuotePopup, assignQuotePopupSaveButtons}
});

export const setAssignQuotePopupSearchText = (assignQuotePopupSearchText) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_SEARCH_TEXT,
  payload: {assignQuotePopupSearchText}
});

export const setAssignQuotePopupEmployee = (assignQuotePopupEmployee) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_EMPLOYEE,
  payload: {assignQuotePopupEmployee}
});

export const setAssignQuotePopupCustomer = (assignQuotePopupCustomer) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_CUSTOMER,
  payload: {assignQuotePopupCustomer}
});

export const setAssignQuotePopupSuccessText = (assignQuotePopupSuccessText) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_SUCCESS_TEXT,
  payload: {assignQuotePopupSuccessText}
});

export const setAssignQuoteCloneMode = (assignQuoteCloneMode) => ({
  type: types.SET_ASSIGN_QUOTE_CLONE_MODE,
  payload: {assignQuoteCloneMode}
});

export const setAssignQuoteOfflineData = (offlineData) => ({
  type: types.SET_ASSIGN_QUOTE_OFFLINE_DATA,
  payload: offlineData
});
